export const GET_PREMIUM = "Get Business";
export const LINK_LOCATION = "link-location";
